import EasyTimePicker from "../components/easyTimePicker/EasyTimePicker.vue";
import { EasyTimePickerRootProps } from "@/src/easy-ui/types/easyTimePicker";

export interface EasyUIAppPayload {
  componentPrefix: string;
  hiddenInputId: string;
  localeKeys: string[];
  props: EasyTimePickerRootProps;
  settingKeys?: string[];
  triggerUpdateEvent: (updatedInput: HTMLInputElement) => void;
  wrapperId: string;
}

export type EasyUIComponents = typeof EasyTimePicker;

export enum RadioGroupDirection {
  Inline = "inline",
  Column = "column",
}

export enum EasyAlerts {
  Success = "success",
  Error = "error",
  Warning = "warning",
  Info = "info",
}

export enum StepSliderDirection {
  Prev = "prev",
  Next = "next",
}

export enum VuetifyOrientation {
  Vertical = "vertical",
  Horizontal = "horizontal",
}

export enum VuetifyChipVariants {
  Flat = "flat",
  Text = "text",
  Elevated = "elevated",
  Tonal = "tonal",
  Outlined = "outlined",
  Plain = "plain",
}

export enum VuetifyAvatarVariants {
  Flat = "flat",
  Text = "text",
  Elevated = "elevated",
  Tonal = "tonal",
  Outlined = "outlined",
  Plain = "plain",
}

export enum VuetifyBtnVariants {
  Outlined = "outlined",
  Plain = "plain",
  Tonal = "tonal",
  Flat = "flat",
  Text = "text",
}

export enum VuetifyAlertVariants {
  Outlined = "outlined",
  Plain = "plain",
  Elevated = "elevated",
  Tonal = "tonal",
  Flat = "flat",
}

export enum VuetifyInputVariants {
  Underlined = "underlined",
  Outlined = "outlined",
  Filled = "filled",
  Solo = "solo",
  SoloInverted = "solo-inverted",
  SoloFilled = "solo-filled",
  Plain = "plain",
}

export enum VuetifyCardVariants {
  Elevated = "elevated",
  Flat = "flat",
  Tonal = "tonal",
  Outlined = "outlined",
  Text = "text",
  Plain = "plain",
}

export enum VuetifyLocations {
  Top = "top",
  Left = "left",
  TopLeft = "top left",
  Right = "right",
  BottomLeft = "bottom left",
  BottomRight = "bottom right",
  RightTop = "right top",
  Bottom = "bottom",
}

export enum VuetifyLocationStrategies {
  Static = "static",
  Connected = "connected",
}

export enum VuetifyColors {
  Primary = "primary",
  Success = "success",
  Secondary = "secondary",
  Warning = "warning",
  Error = "error",
  Info = "info",
  Muted = "muted",
}

export enum VuetifyAligns {
  Start = "start",
  Center = "center",
  End = "end",
}

export enum VuetifyDensity {
  Default = "default",
  Comfortable = "comfortable",
  Compact = "compact",
}

export enum VuetifySizes {
  Default = "default",
  Large = "large",
  Small = "small",
  XLarge = "x-large",
  XSmall = "x-small",
}

export enum VuetifyOverlayTriggers {
  Click = "click",
  Hover = "hover",
}

export enum VuetifyValidateOn {
  Blur = "blur",
  Input = "input",
  Submit = "submit",
  InvalidInput = "invalid-input",
  BlurLazy = "blur lazy",
  InputLazy = "input lazy",
  SubmitLazy = "submit lazy",
  InvalidInputLazy = "invalid-input lazy",
  BlurEager = "blur eager",
  InputEager = "input eager",
  SubmitEager = "submit eager",
  InvalidInputEager = "invalid-input eager",
  LazyBlur = "lazy blur",
  LazyInput = "lazy input",
  LazySubmit = "lazy submit",
  LazyInvalidInput = "lazy invalid-input",
  EagerBlur = "eager blur",
  EagerInput = "eager input",
  EagerSubmit = "eager submit",
  EagerInvalidInput = "eager invalid-input",
  Lazy = "lazy",
  Eager = "eager",
}

export enum VuetifyTransitions {
  SlideX = "slideX",
}

export enum EasyCardBorderColors {
  BorderOutline = "border-outline",
}
